const getControlCenterReducer = state => state.controlCenter;
const getUIReducer = state => state.ui;

export default {
  initiatorSource: store => getControlCenterReducer(store).initiatorSource,
  fullCorrelationId: store => getControlCenterReducer(store).fullCorrelationId,
  fullOpenScope: store => getControlCenterReducer(store).fullOpenScope,
  miniCorrelationId: store => getControlCenterReducer(store).miniCorrelationId,
  miniOpenScope: store => getControlCenterReducer(store).miniOpenScope,
  miniVisible: store => getControlCenterReducer(store).miniVisible,
  enabled: store => getControlCenterReducer(store).enabled,
  isMounted: store => getUIReducer(store).controlCenterMounted
};
